const _MS_PER_DAY = 1000 * 60 * 60 * 24;
// a and b are javascript Date objects
export function dateDiffInDays(a, b) {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function mysqlDate(datetime) {
  const date = new Date(datetime).toJSON().slice(0, 10);
  // const date = new Date().toJSON().slice(0, 10);
  // console.log(date) //2015-07-23
  return date;
}

export const mysqlDateHm = (datetime) =>
  new Date(datetime).toJSON().slice(0, 16).replace("T", " ");

export const mysqlDateTime = (datetime) =>
  new Date(datetime).toJSON().slice(0, 19).replace("T", " ");
// console.log(datetime) //2015-07-23 11:26:00

// I needed this for a filename and with the time in the current timezone.
const timezoneOffset = new Date().getTimezoneOffset() * 60000;
const date = new Date(Date.now() - timezoneOffset)
  .toISOString()
  .substring(0, 19)
  .replace("T", "") // replace T with a space
  .replace(/ /g, "_") // replace spaces with an underscore
  .replace(/\:/g, "."); // replace colons with a dot

// mysql style output
export function getCurrentDatetime() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var day = now.getDate();
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  if (month.toString().length == 1) {
    month = "0" + month;
  }
  if (day.toString().length == 1) {
    day = "0" + day;
  }
  if (hour.toString().length == 1) {
    hour = "0" + hour;
  }
  if (minute.toString().length == 1) {
    minute = "0" + minute;
  }
  if (second.toString().length == 1) {
    second = "0" + second;
  }
  var dateTime =
    year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
  return dateTime;
}
